import React from 'react'
import { getIn } from 'formik'
import { Span } from '@fareye/ui'

export function CustomErrorMessage(props: any) {
  const { children, formKey } = props
  let message = ''
  if (formKey && typeof children != 'string') {
    message = getIn(children, formKey)
  } else if (typeof children == 'string') {
    message = children
  }
  return (
    <Span variant="danger" p={2}>
      {message}
    </Span>
  )
}
